import {COLORS, DOMINOES, GROUPES, SESSION} from 'redux/actionTypes';

import fetchAllGeneric from 'redux/actions/generic/fetchAll';
import fetchOnceGeneric from 'redux/actions/generic/fetchOnce';
import updateGeneric from 'redux/actions/generic/update';
import saveGeneric from 'redux/actions/generic/save';
import deleteGeneric from 'redux/actions/generic/delete';
import Api from 'services/Api';

const URL = 'sessions';
export const fetchAll = (page = 1, limit = 20, params = {}) => {
	return fetchAllGeneric({
		itemsPerPage: limit,
		page: page,
		...params
	}, SESSION, URL);
};

export const deleteItem = (id, callback, options = {}) => {
	let url = URL;
	if (typeof options.url !== 'undefined') {
		url = options.url;
	}
	return deleteGeneric(id, SESSION, url, callback, options);
}


export const fetchOnce = (id, callback, defaultValues = {}) => {
	return fetchOnceGeneric(id, SESSION, URL, callback, defaultValues);
};

export const update = (id, data, callback) => {
	return updateGeneric(id, data, SESSION, URL, callback, (dispatch, item) => {
		dispatch({
			type: SESSION.UPDATE_NAME,
			payload: {
				name: item.name
			}
		});
	});
}
export const save = (data, callback) => {
	return saveGeneric(data, SESSION, URL, callback);
}

export const updateSetup = (setup, callback) => {
	return (dispatch) => {
		dispatch({
			type: SESSION.UPDATE_SETUP,
			payload: setup
		});
		Api.post(
			setup,
			'setup/update',
			(error, data) => {

				if (typeof callback === 'function') {
					callback(data);
				}

				return dispatch({
					type: SESSION.GET,
					payload: data
				});

			}
		);
	}
}

export const get = (idSession) => {
	return (dispatch) => {
		dispatch({
			type: SESSION.FETCHING,
		});
		Api.get(
			{
				idSession
			},
			'session/',
			(error, data) => {
				if (error) {
					return dispatch({
						type: SESSION.ERROR,
						payload: {
							message: error,
						},
					});
				}

				if (typeof data.palettes !== 'undefined') {
					dispatch({
						type: COLORS.SET,
						payload: {
							palettes: data.palettes,
							index: 0
						}
					});
				}

				if (typeof data.dominoes !== 'undefined') {
					dispatch({
						type: DOMINOES.SET,
						payload: {
							dominoes: data.dominoes
						}
					});
				}
				if (typeof data.groups !== 'undefined') {
					dispatch({
						type: GROUPES.SET_GROUPES,
						payload: {
							groupes: data.groups
						}
					});
				}

				return dispatch({
					type: SESSION.GET,
					payload: data
				});
			}
		);
	};
};
